import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { useActivateSim } from "./hook/useActivateSim";
import { pukCodeRegex } from "@utils/formControl";
import { Loader } from "@common/handleErrorAndLoading/Loader";
import { useHistory } from "react-router-dom";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { URLS } from "@constants";

export const ActivateSim = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activateSimSuccess, setActivateSimSuccess] = useState<boolean>(false);
    const history = useHistory();

    const finaliseActivateSimCallback = (result: boolean) => {
        setActivateSimSuccess(result);
        setIsModalOpen(true);
    };

    const { formMethods, validationCodeState, handleSubmit } = useActivateSim(finaliseActivateSimCallback);
    const { error, isLoading } = validationCodeState;
    const { t } = useTranslation(["sim", "common", "glossary", "validation"]);

    const closeModal = () => {
        if (activateSimSuccess) history.push(fixUrlLanguage(URLS.HOME_PAGE_URL_EN));
        else setIsModalOpen(false);
    };

    const { errors, register } = formMethods;

    return (
        <Card className="activateSim" elevation={2}>
            <CardHeader
                style={{ paddingBottom: "10px" }}
                title={t("sim:activateReplacementSim")}
                titleTypographyProps={{ variant: "h2", color: "primary", align: "center" }}
            />
            <Divider light style={{ marginBottom: "10px" }} variant="middle" />
            <CardContent>
                <Typography align="center" gutterBottom={Boolean(error)} variant="body1">
                    {t("sim:activateReplacementSimHelperText")}
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container justify="center" spacing={2}>
                        <Grid item md={7} sm={11} xs={12}>
                            <TextField
                                error={Boolean(errors.activationCode)}
                                fullWidth
                                helperText={errors.activationCode?.message}
                                id="activationCode"
                                inputRef={register({
                                    required: t("validation:required"),
                                    validate: pukCodeRegex,
                                })}
                                label={t("sim:enterPuk")}
                                margin="dense"
                                name="activationCode"
                                type="text"
                                disabled={isLoading}
                            />
                        </Grid>
                        {error && (
                            <Grid item xs={12}>
                                <Typography align="center" color="error" gutterBottom>
                                    {error.errorMessage || t("common:genericError")}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Grid container justify="center">
                                {isLoading && <Loader size={40} />}
                                {!isLoading && (
                                    <Button color="primary" size="large" type="submit" variant="contained">
                                        {t("sim:activateSim")}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                <Modal
                    close={closeModal}
                    confirm={closeModal}
                    confirmLabel={t("glossary:close")}
                    content={activateSimSuccess ? t("sim:activateSimSuccess") : t("sim:activateSimFailed")}
                    isModalOpen={isModalOpen}
                    title=""
                />
            </CardContent>
        </Card>
    );
};
